import isEqual from "lodash/isEqual";
import {IntermediatePart} from "../../parts/intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";

import { Shower } from "../../parts/shower";
import { ShowerTubCombo } from "../../parts/showerTubCombo";

export default class ShowerInteriorWallAccent extends IntermediatePart {

  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partId = "shower_interior_wall_accent";
    this.partName = "Shower Walls Accent";
    this.translateId = "visualizer.bathroom.shower.shower_interior_wall_accent";
    this.dbName = "Shower Wall Accent";
    // this.homePageTitle = 'Interior Shower Walls';
    this.isStoneFeature = true;
    this.partNumber = partNumber;
    this.activeFeatureParts = [];
    this.canBeDisabled = true;
    this.layerPriority = 3;
  }

  load(dbFeature) {
    const parts = dbFeature.metaData && dbFeature.metaData["Parts"];
    if (parts) {
      const partNumber = +dbFeature.metaData["Part"][0];
      return super.load_(
        dbFeature,
        new ShowerInteriorWallAccent(false, partNumber),
        true,
        partNumber === 1 ? 'features' : 'featuresParts'
      );
    } else {
      return super.load_(dbFeature, new ShowerInteriorWallAccent());
    }
  }

  disabledClick() {
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
  }

  handleClick(ignoreLocked) {
    const parent = this.getParent();
    if (parent.getParent && parent.getParent()) {
      super.handleClick(ignoreLocked);
      parent.activeFeatureParts = parent.setActiveFeatureParts();
    } else {
      parent.showerInteriorWallAccent.activeFeature = this;
    }
    this.featureClicked();
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(this.availableFeatures(super.getFilteredFeaturesByFilters(filters)), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  availableFeatures(wallFeatures) {
    return wallFeatures.filter(wallFeature => wallFeature.partNumber === 1)
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
        || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      this.activeFeatureParts = this.setActiveFeatureParts();
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    const matchingFeatureExist = super.tryToSetTheSameFeature(filteredFeatures, null, null, true);
    if (!matchingFeatureExist) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Tan Hexagon");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
      this.activeFeatureParts = this.setActiveFeatureParts();
    } else {
      this.activeFeatureParts = this.setActiveFeatureParts();
    }
    this.setShadowFeature();
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    const activeShowerPartId = showerParent.showerTubComboIsActive() ? ShowerTubCombo.id : Shower.id;
    const showerSize = showerParent.layout.parts[activeShowerPartId].showerSize();
    return [{
      propName: 'ShowerSize',
      propValue: showerSize
    }];
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.Custom60in.WallAccent;
    const zIndex2 = zIndexes.Shower.Custom60in.WallAccent2;

    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.activeFeatureParts.length) {
      this.activeFeatureParts.forEach((activeFeaturePart) => {
        if (activeFeaturePart && activeFeaturePart.layer) {
          activeFeaturePart.layer.zIndex = zIndex2
        }
      })
    }
  }

  setActiveFeatureParts() {
    const activeFeature = this.placeholderChanged ? this.activeFeature : this.placeholderFeature;
    if (activeFeature) {
      const showerSize = activeFeature.metaData["ShowerSize"];
      const name1 = activeFeature.getSplittedFeatureName().split("30in ")[0].split("60in ")[0];
      const activeFeaturePart = activeFeature.partNumber && showerSize ? this.featuresParts.find((feature) => {
        const showerSize2 = feature.metaData["ShowerSize"];
        const name2 = feature.getSplittedFeatureName().split("30in ")[0].split("60in ")[0];
        return showerSize2 && isEqual(showerSize, showerSize2) && (feature.partName === activeFeature.partName || name1 === name2)
      }) : [];
      if (activeFeaturePart) {
        activeFeaturePart.disabled = this.disabled;
        return [activeFeaturePart]
      }
    }
    return []
  }
}
